<template>
  <v-container>
    <v-row class="align-center justify-center">
      <v-col cols="12" md="12" align-self="center">
        <div id="chart-hectare"></div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Highcharts from "highcharts"
import Exporting from 'highcharts/modules/exporting'
import Accessibility from "highcharts/modules/accessibility";
Accessibility(Highcharts);
Exporting(Highcharts)
export default {
  props: ['hectareSeries','text','firstYear','lastYear'],
  name: "HectareChart",
  mounted() { this.dataSource() },
  watch: {
    hectareSeries(){
      if(this.hectareSeries){
        this.dataSource()
      }
    }
  },
  methods: {
    async dataSource(){
      let chart = document.getElementById('chart-hectare')
      if(this.hectareSeries){
        this.chartNew(this.hectareSeries)
        chart.style.visibility = 'visible'
        chart.style.display = 'block'
      } else {
        chart.style.visibility = 'hidden'
        chart.style.display = 'none'
      }
      this.$emit('chartRenderComplete', this.chartRendered);
    },
    chartNew(series) {
      this.chartRendered = Highcharts.chart('chart-hectare', {
        chart: {
          type: 'area',
          zoomType: 'x',
          backgroundColor: this.$vuetify.theme.themes.dark.primary.darken1,
        },
        title: { text: null },
        subtitle: { text: null },
        credits: {
          enabled: false,
          href: 'http://www.simepar.br/',
          text:'by: SIMEPAR',
          style:{ color: '#FFFFFF'}
        },
        exporting: {
          enabled: false,
          filename: this.text,
          chartOptions: {
            title: {
              text: this.text,
              style: {
                color: '#FFFFFF'
              }
            },
          }
        },
        legend: {
          enabled: true,
          itemStyle:{ color: '#FFFFFF' },
          itemHoverStyle: { color: '#979797' },
        },
        xAxis: {
          gridLineWidth: 1,
          gridLineColor:'#2D324F',
          type: 'datetime',
          tickmarkPlacement: 'on',
          labels: {
            style:{ color: '#FFFFFF'}
          },
          title: {
            enabled: false,
            style:{ color: '#FFFFFF'}
          },
          accessibility: {
            description: `De ${this.firstYear} até ${this.lastYear}`,
          },
        },
        yAxis: {
          min: 0,
          //max: y.max,
          endOnTick: false,
          gridLineWidth: 1,
          gridLineColor:'#2D324F',
          //startOnTick: false,
          //tickInterval: 10000,
          labels: {
            format: '{value}',
            style:{ color: '#FFFFFF'}
          },
          title: {
            enabled: true,
            text: 'área (ha)',
            style:{ color: '#FFFFFF'}
          },
          accessibility: {
            description: "área (ha)",
          },
        },
        tooltip: {
          valueSuffix: ' ha',
          split: true,
        },
        plotOptions: {
          area: {
            stacking: 'normal',
            lineColor: '#ffffff',
            lineWidth: 1,
            marker: {
              lineWidth: 1,
              lineColor: '#ffffff'
            },
/*            accessibility: {
              pointDescriptionFormatter: function (point) {
                function round(x) {
                  return Math.round((x * 100) / 100);
                }
                return (point.index + 1) + ', ' + point.category + ', ' +
                  point.y + ' ha, ' + round(point.percentage) + '%, ' +
                  point.series.name;
              }
            }*/
          }
        },
        series: [...series],
        caption: {
          text: `Gráfico empilhado baseado na área total da bacia - Dados históricos da evolução do uso e cobertura da terra em Hectare (ha) de ${this.firstYear} até ${this.lastYear}`,
          style: { color: "#FFFFFF" },
        },
      });
    },
  },
}
</script>

<style scoped>

</style>
